// extracted by mini-css-extract-plugin
export default {"container":"OwnerWithoutCab_container__SFbEh","cabine":"OwnerWithoutCab_cabine__WSA0D"};